module.exports = __webpack_public_path__ + "img/feature_buy_en.7ca13bd4.png";